import { type Table } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FaFileCsv, FaFilePdf, FaChevronDown } from "react-icons/fa";

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>;
  onExportCSV?: () => void;
  onExportPDF?: (orientation: "portrait" | "landscape") => void;
}

export function DataTableViewOptions<TData>({
  table,
  onExportCSV = () => null,
  onExportPDF = () => null,
}: DataTableViewOptionsProps<TData>) {
  return (
    <div className="flex justify-between items-center gap-3">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="bg-primary text-sm text-black flex items-center gap-1 lg:mb-0 h-8 px-2">
            <i className="fa-solid fa-download text-black size-3.5"></i>
            Export
            <FaChevronDown className="size-2.5 text-black" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-fit">
          <DropdownMenuItem onClick={onExportCSV} className="cursor-pointer">
            <FaFileCsv className="size-3.5 text-green-600 mr-2" />
            CSV
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={() => onExportPDF("portrait")}
            className="cursor-pointer"
          >
            <FaFilePdf className="size-3.5 text-red-600 mr-2" />
            PDF
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
